import type { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useCurrency } from '../../../contexts/CurrencyContext';
import { formatCurrency } from '../../../utils/currency';
import { Text } from '../../typography';

export interface SalePriceProps {
    price: number;
    isPriceHeader?: boolean;
    isDrawer?: boolean;
    id?: string;
}

export const SalePrice: FC<SalePriceProps> = ({ price, isPriceHeader, isDrawer, id }) => {
    const currency = useCurrency();
    const intl = useIntl();
    const formattedPrice = formatCurrency(price, currency, intl.locale);

    if (isPriceHeader && !isDrawer) {
        return (
            <Text id={id} color="slt-red.1000" margin="0 4px 0 0" style="bolder" size="base">
                <FormattedMessage id="sale" defaultMessage="Sale" /> {formattedPrice}
            </Text>
        );
    }

    return (
        <Text id={id} margin="0 4px 0 0" color="slt-red.1000" as="span" style="bold" size="base">
            <FormattedMessage id="sale" defaultMessage="Sale" /> {formattedPrice}
        </Text>
    );
};
